import { useCallback, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

import { FatalAttraction } from '@vpr/tracking';

import { BigPictureClient, Event } from '@vimeo/bigpicture-client';
import { translate } from '@vimeo/i18n-runtime';
import { Pop } from '@vimeo/iris/components';
import { Text } from '@vimeo/iris/typography';

import { InlineLink } from './desktop/StandardFooter';
import * as Links from './Links';
import { PopItem } from '../nav/desktop/userMenus/PopOverList';

interface Props {
  footerType?: 'standard' | 'standardMobile' | 'essential' | 'minimal' | 'minimalMobile';
  isDoNotSellReady?: boolean;
}

const Link = styled.a`
  cursor: pointer;
`;

const DoNotSellLink = ({ footerType = 'standard', isDoNotSellReady }: Props) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const selfWithAirgap = useRef<any | undefined>(undefined);
  const [showSellLink, setShowSellLink] = useState(false);

  const handleConsent = () => {
    FatalAttraction.trackClick({
      component: 'footer',
      target: 'transcend_dialogue_box',
      keyword: 'do_not_sell_my_personal_information',
      container: 'footer',
    });
    BigPictureClient.sendEvent(
      new Event('vimeo.click', 75, {
        page: 'footer',
        location: 'footer',
        target: 'transcend_dialogue_box',
        name: 'do_not_sell',
        copy: 'do_not_sell_my_personal_information',
        feature: 'do_not_sell',
        type: 'general',
      }),
    );
    selfWithAirgap.current?.transcend.showConsentManager({ viewState: 'DoNotSellExplainer' });
  };

  const onScriptLoad = useCallback(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    selfWithAirgap.current = self as any;
    const { airgap } = selfWithAirgap.current;
    try {
      // Only show the button in california
      if (airgap && airgap.getRegimes?.().has('CPRA')) {
        airgap.ready(() => {
          setShowSellLink(true);
        });
      }
    } catch (e) {
      console.error(e);
    }
  }, []);

  useEffect(() => {
    if (isDoNotSellReady) onScriptLoad();
  }, [isDoNotSellReady, onScriptLoad]);

  return showSellLink ? (
    <>
      {footerType === 'standard' && ' | '}
      <Link
        onClick={() => handleConsent()}
        onKeyPress={(event) => {
          if (event.key === 'Enter') handleConsent();
        }}
        tabIndex={0}
      >
        {footerType === 'standard' && (
          <InlineLink as="span">{translate('Do Not Sell My Personal Information')}</InlineLink>
        )}
        {footerType === 'standardMobile' && (
          <Links.Link as="span" title={translate('Do Not Sell My Personal Information')}>
            {translate('Do Not Sell My Personal Information')}
          </Links.Link>
        )}
        {footerType === 'essential' && (
          <Pop.Item>
            <Text>{translate('Do Not Sell My Personal Information')}</Text>
          </Pop.Item>
        )}
        {footerType === 'minimal' && (
          <PopItem title={translate('Do Not Sell My Personal Information')}>
            {translate('Do Not Sell My Personal Information')}
          </PopItem>
        )}
        {footerType === 'minimalMobile' && (
          <Links.Link as="span" title={translate('Do Not Sell My Personal Information')}>
            {translate('Do Not Sell My Personal Information')}
          </Links.Link>
        )}
      </Link>
    </>
  ) : null;
};

export default DoNotSellLink;
